import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index.vue'
import Login from '../views/login.vue'
import Register from '../views/register.vue'
import Forget from '../views/forget.vue'
import Apply from '../views/apply.vue'
import Account from '../views/account.vue'
import MyOrder from '../views/myorder.vue'
import OrderInfo from '../views/orderInfo.vue'
import Order from '../views/order.vue'
import SignUp from '../views/signup.vue'
import Protocol from '../views/protocol.vue'
import Wenhuaguan from '../views/wenhuaguan.vue'
import Notice from '../views/notice.vue'
import MyCourse from '../views/myCourse.vue'
import Notice2 from '../views/notice2.vue'
import Opinion from '../views/opinion.vue'
import ActList from '../views/activityList.vue'
import OrderFeiyi from "../views/order_feiyi.vue"
Vue.use(VueRouter)

const routes = [
  {
    path: '/index',
    name: '首页',
    component: Index,
    meta: {
      title: '首页'
    }
  }, {
    path: '/login',
    name: '登录',
    component: Login,
    meta: {
      title: '登录'
    }
  }, {
    path: '/register',
    name: '注册',
    component: Register,
    meta: {
      title: '注册'
    }
  }, {
    path: '/forget',
    name: '重置密码',
    component: Forget,
    meta: {
      title: '重置密码'
    }
  }, {
    path: '/apply',
    name: '网上报名',
    component: Apply,
    meta: {
      title: '网上报名'
    }
  }, {
    path: '/account',
    name: '账号设置',
    component: Account,
    meta: {
      title: '账号设置'
    }
  }, {
    path: '/myorder',
    name: '我的预约',
    component: MyOrder,
    meta: {
      title: '我的预约'
    }
  }, {
    path: '/orderInfo',
    name: '预约信息',
    component: OrderInfo,
    meta: {
      title: '预约信息'
    }
  }, {
    path: '/order',
    name: '场馆预约',
    component: Order,
    meta: {
      title: '场馆预约'
    }
  }, {
    path: '/signup',
    name: '报名',
    component: SignUp,
    meta: {
      title: '报名'
    }
  }, {
    path: '/activityList',
    name: '活动列表',
    component: ActList,
    meta: {
      title: '活动列表'
    }
  }, {
    path: '/protocol',
    name: '报名信息',
    component: Protocol,
    meta: {
      title: '报名信息'
    }
  }, {
    path: '/wenhuaguan',
    name: '文化馆',
    component: Wenhuaguan,
    meta: {
      title: '文化馆'
    }
  }, {
    path: '/notice',
    name: '学员须知',
    component: Notice,
    meta: {
      title: '学员须知'
    }
  }, {
    path: '/MyCourse',
    name: '我的报名',
    component: MyCourse,
    meta: {
      title: '我的报名'
    }
  }, {
    path: '/notice2',
    name: '预约须知',
    component: Notice2,
    meta: {
      title: '预约须知'
    }
  }, {
    path: '/opinion',
    name: '意见反馈',
    component: Opinion,
    meta: {
      title: '意见反馈'
    }
  }, {
    path: '/activity',
    name: '活动报名',
    component: () => import('../views/activity.vue'),
    meta: {
      title: '活动报名'
    }
  }, {
    path: '/myActivity',
    name: '我的活动',
    component: () => import('../views/myActivity.vue'),
    meta: {
      title: '我的活动'
    }
  }, {
    path: '/order_feiyi',
    name: '文化馆非遗展厅预约',
    component: () => import("../views/order_feiyi.vue"),
    meta: {
      title: '文化馆非遗展厅预约'
    }
  }, {
    path: '/myorder_feiyi',
    name: '我的非遗展厅预约',
    component: () => import("../views/myorder_feiyi.vue"),
    meta: {
      title: '我的非遗展厅预约'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
